import { render, staticRenderFns } from "./DatasetFields.vue?vue&type=template&id=9e324fec"
import script from "./DatasetFields.vue?vue&type=script&lang=js"
export * from "./DatasetFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports